"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DatePreset = void 0;
var DatePreset;
(function (DatePreset) {
    DatePreset["LAST_FIFTEEN_MINUTES"] = "lastFifteenMinutes";
    DatePreset["LAST_HOUR"] = "lastHour";
    DatePreset["TODAY"] = "today";
    DatePreset["LAST_TWO_DAYS"] = "lastTwoDays";
    DatePreset["LAST_WEEK"] = "lastWeek";
    DatePreset["LAST_TWO_WEEKS"] = "lastTwoWeeks";
    DatePreset["LAST_MONTH"] = "lastMonth";
})(DatePreset = exports.DatePreset || (exports.DatePreset = {}));
